import { GEO_VIEWBOX, COUNTRY_POINTS, project } from "./liveMapGeo";

export const VIEWBOX = GEO_VIEWBOX;

// Posicion geografica real: el punto representativo de cada pais pasado por
// la misma proyeccion que genero los contornos del fondo (liveMapGeo.js).
const KNOWN_POSITIONS = Object.fromEntries(
  Object.entries(COUNTRY_POINTS).map(([code, p]) => [code, { ...project(p.lat, p.lon), label: p.label || "b" }]),
);

// Paises sin punto conocido: grilla en el Pacifico sur (abajo a la izquierda,
// sin tierra), de a UNKNOWN_PER_ROW por fila y subiendo.
const UNKNOWN_PER_ROW = 4;
const UNKNOWN_ORIGIN = { x: 60, y: VIEWBOX.h - 40 };
const UNKNOWN_STEP = { x: 90, y: 50 };

export const STATUS_TONE = {
  executing: "moving",
  processing: "moving",
  awaiting_funding: "moving",
  // OPS-29: ejecutada, esperando al destinatario. En transito, no final.
  pending_claim: "waiting",
  completed: "done",
  failed: "bad",
  reversed: "bad",
};

const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));

export function tokenSpec(amountUsd, kind) {
  const amount = Number.isFinite(amountUsd) && amountUsd > 0 ? amountUsd : 0;
  const small = amount < 100;
  const count = small
    ? clamp(Math.ceil(amount / 20), 1, 5)
    : clamp(Math.round(amount / 100), 1, 10);
  if (kind === "points") return { type: "chip", count };
  return { type: small ? "coin" : "bill", count };
}

export function nodePosition(code, unknownIndex = 0) {
  if (KNOWN_POSITIONS[code]) return KNOWN_POSITIONS[code];
  const col = unknownIndex % UNKNOWN_PER_ROW;
  const row = Math.floor(unknownIndex / UNKNOWN_PER_ROW);
  return { x: UNKNOWN_ORIGIN.x + col * UNKNOWN_STEP.x, y: UNKNOWN_ORIGIN.y - row * UNKNOWN_STEP.y, label: "b" };
}

export function buildNodes(codes) {
  const unknown = [...new Set(codes)].filter((c) => !KNOWN_POSITIONS[c]).sort();
  const known = [...new Set(codes)].filter((c) => KNOWN_POSITIONS[c]);
  return [
    ...known.map((code) => ({ code, ...KNOWN_POSITIONS[code] })),
    ...unknown.map((code, i) => ({ code, ...nodePosition(code, i) })),
  ];
}

export function arcPath(from, to) {
  if (from.x === to.x && from.y === to.y) {
    const { x, y } = from;
    return `M ${x} ${y} C ${x - 40} ${y - 70}, ${x + 40} ${y - 70}, ${x} ${y}`;
  }
  const mx = (from.x + to.x) / 2;
  const my = (from.y + to.y) / 2;
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const len = Math.hypot(dx, dy) || 1;
  const bend = Math.min(120, len * 0.35);
  const cx = mx - (dy / len) * bend;
  const cy = my + (dx / len) * bend * -1;
  return `M ${from.x} ${from.y} Q ${cx} ${cy}, ${to.x} ${to.y}`;
}

export function diffTransactions(seen, txs) {
  const next = new Map(seen);
  const fresh = [];
  const changed = [];
  for (const tx of txs) {
    const prev = next.get(tx.id);
    if (prev === undefined) fresh.push(tx);
    else if (prev !== tx.status) changed.push(tx);
    next.set(tx.id, tx.status);
  }
  return { fresh, changed, next };
}
